import { Link } from 'react-router-dom';
import { useState } from 'react';
import { useSEO } from '@/hooks/useSEO';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

const SUBMISSION_FORM_URL = 'https://readdy.ai/api/form/d95mn1ih9roq6qfrc7g0';

const faqData = [
  {
    question: '51爆料的信息来源可靠吗？',
    answer: '51爆料所有内容均经过至少两位编辑交叉验证。我们的记者团队遍布全国主要城市，与多位娱乐圈从业者保持长期合作关系，确保每一条爆料都有据可查。',
  },
  {
    question: '我可以投稿爆料吗？',
    answer: '当然可以！如果你有任何有价值的爆料信息，欢迎通过本站的投稿表单提交。我们会保护你的隐私，所有投稿来源均严格保密。',
  },
  {
    question: '51爆料的内容收费吗？',
    answer: '所有基础爆料内容均免费向公众开放。我们致力于让每一个人都能平等地获取信息。',
  },
  {
    question: '如何联系51爆料团队？',
    answer: '你可以通过本站的投稿表单、官方社交媒体账号或邮件与我们联系。我们承诺在48小时内回复所有合作咨询。',
  },
  {
    question: '51爆料会删除不实信息吗？',
    answer: '我们设有严格的审核机制和纠错流程。如果任何内容被证实有误，我们会在第一时间发布更正声明并修改原文。',
  },
];

export default function AboutPage() {
  useSEO({
    title: '关于我们 | 51爆料 - 爆料黑料第一站',
    description: '51爆料是吃瓜爆料黑料第一站，专注网红翻车、擦边反差、明星八卦的24小时实时更新。了解我们的品牌故事、团队实力与业务矩阵。',
    keywords: '51爆料,关于我们,品牌介绍,吃瓜爆料,网红翻车,明星黑料,投稿爆料',
    url: 'https://www.51baoliao.com/about',
    type: 'webpage',
    breadcrumbs: [
      { name: '首页', url: 'https://www.51baoliao.com/' },
      { name: '关于我们', url: 'https://www.51baoliao.com/about' },
    ],
    faq: faqData,
  });

  const [formData, setFormData] = useState({ name: '', email: '', content: '' });
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [submitMsg, setSubmitMsg] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const form = e.currentTarget;
    const formPayload = new FormData(form);
    const honeypot = (formPayload.get('website_alt') as string || '').trim();
    if (honeypot) {
      setSubmitStatus('success');
      setSubmitMsg('投稿提交成功！我们会尽快审核。');
      setFormData({ name: '', email: '', content: '' });
      return;
    }

    setSubmitStatus('loading');
    try {
      const res = await fetch(SUBMISSION_FORM_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({
          name: formPayload.get('name') as string,
          email: formPayload.get('email') as string,
          content: formPayload.get('content') as string,
        }).toString(),
      });
      const text = await res.text();
      let parsed: any = {};
      try { parsed = JSON.parse(text); } catch { /* ignore parse errors */ }
      if (res.ok && parsed?.code === 'OK') {
        setSubmitStatus('success');
        setSubmitMsg('投稿提交成功！我们会尽快审核。');
        setFormData({ name: '', email: '', content: '' });
      } else {
        const msg = parsed?.meta?.message || parsed?.message || '提交失败，请稍后再试';
        setSubmitStatus('error');
        setSubmitMsg(msg);
      }
    } catch {
      setSubmitStatus('error');
      setSubmitMsg('网络错误，请稍后再试');
    }
  };

  return (
    <>
      <Navbar />
      <main>
        {/* Hero */}
        <section className="relative w-full min-h-[420px] md:min-h-[520px] flex items-end overflow-hidden bg-background-100 pt-24">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Abstract%20team%20silhouettes%20standing%20in%20dramatic%20warm%20amber%20spotlight%20against%20dark%20background%2C%20journalism%20investigation%20team%20vibe%2C%20mysterious%20atmosphere%2C%20cinematic%20composition%2C%20rich%20burgundy%20and%20gold%20tones%2C%20editorial%20photography%2C%20abstract%20metaphor%20for%20truth%20seeking&width=1600&height=800&seq=about-hero-2026&orientation=landscape"
              alt="51爆料团队"
              className="w-full h-full object-cover object-top"
              title="51爆料团队"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-black/20 to-black/30"></div>
          </div>
          <div className="relative z-10 w-full px-4 md:px-6 pb-10 md:pb-14">
            <div className="flex flex-col lg:flex-row items-start lg:items-end gap-6 lg:gap-16">
              <div className="flex-1">
                <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-black text-background-50 leading-tight tracking-tight">
                  爆料黑料<br />第一站
                </h1>
              </div>
              <div className="flex-1 lg:pb-1">
                <p className="text-background-50/70 text-sm md:text-base leading-relaxed mb-3 max-w-md">
                  51爆料成立于2019年，是国内领先的娱乐八卦爆料平台。我们坚持真实、深度、独家的新闻理念，致力于让每一个人都能第一时间获取热点内幕。
                </p>
                <Link
                  to="#contact"
                  className="group inline-flex items-center gap-2 text-accent-500 font-semibold text-sm hover:text-accent-400 transition-colors cursor-pointer"
                >
                  联系我们
                  <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
                </Link>
              </div>
            </div>
          </div>
        </section>

        {/* Breadcrumb */}
        <div className="w-full bg-background-50 border-b border-background-200/70 px-4 md:px-6 py-3">
          <nav aria-label="面包屑导航">
            <ol className="flex items-center gap-2 text-sm">
              <li>
                <Link to="/" className="text-foreground-500 hover:text-foreground-700 transition-colors">首页</Link>
              </li>
              <li className="text-foreground-300"><i className="ri-arrow-right-s-line text-xs"></i></li>
              <li className="text-primary-600 font-medium" aria-current="page">关于我们</li>
            </ol>
          </nav>
        </div>

        {/* Brand Strength */}
        <section className="w-full bg-background-100 py-14 md:py-20">
          <div className="w-full px-4 md:px-6">
            <div className="mb-10 md:mb-14">
              <p className="text-foreground-400 text-xs font-semibold uppercase tracking-wider mb-3">品牌实力</p>
              <p className="text-foreground-700 text-base md:text-lg leading-relaxed max-w-2xl">
                从2019年创立至今，51爆料始终坚持"真实第一"的原则。我们不洗白、不站队、不造谣，只陈述事实。五年来，我们累计发布爆料超过两万条，帮助数十位当事人还原真相，也曾因报道不实而主动道歉更正。
              </p>
            </div>

            <div className="grid grid-cols-2 gap-6 md:gap-10">
              <div>
                <div className="flex items-baseline gap-1">
                  <span className="font-heading text-4xl md:text-6xl font-black text-foreground-950">20000</span>
                  <span className="text-accent-500 text-xl md:text-3xl font-bold">+</span>
                </div>
                <p className="text-foreground-400 text-sm mt-1">累计爆料数</p>
              </div>
              <div>
                <div className="flex items-baseline gap-1">
                  <span className="font-heading text-4xl md:text-6xl font-black text-foreground-950">350</span>
                  <span className="text-accent-500 text-xl md:text-3xl font-bold">+</span>
                  <span className="text-foreground-400 text-lg">位</span>
                </div>
                <p className="text-foreground-400 text-sm mt-1">合作信源</p>
              </div>
              <div>
                <div className="flex items-baseline gap-1">
                  <span className="font-heading text-4xl md:text-6xl font-black text-foreground-950">94%</span>
                </div>
                <p className="text-foreground-400 text-sm mt-1">内容真实率</p>
              </div>
              <div>
                <div className="flex items-baseline gap-1">
                  <span className="font-heading text-4xl md:text-6xl font-black text-foreground-950">15</span>
                  <span className="text-foreground-400 text-lg">分钟内</span>
                </div>
                <p className="text-foreground-400 text-sm mt-1">重大事件响应速度</p>
              </div>
            </div>
          </div>
        </section>

        {/* Endorsements */}
        <section className="w-full bg-secondary-50/50 py-14 md:py-20">
          <div className="w-full px-4 md:px-6">
            <div className="text-center mb-10 md:mb-14">
              <div className="inline-flex items-center gap-2 mb-4">
                <span className="w-3 h-3 bg-accent-500 rounded-full"></span>
                <span className="text-accent-700 text-xs font-semibold uppercase tracking-wider">口碑背书</span>
              </div>
              <h2 className="font-heading text-3xl md:text-5xl font-black text-foreground-950">
                他们都在推荐
              </h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
              <div className="bg-background-50 rounded-2xl p-5 md:p-6 border border-secondary-200/60">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                    <img
                      src="https://readdy.ai/api/search-image?query=Stylized%20abstract%20portrait%20of%20media%20professional%2C%20warm%20amber%20and%20cream%20tones%2C%20minimalist%20illustration%20style%2C%20clean%20background%2C%20modern%20aesthetic%2C%20confident%20expression&width=100&height=100&seq=endorse-avatar-01&orientation=squarish"
                      alt="媒体人老王"
                      className="w-full h-full object-cover"
                      title="媒体人老王"
                    />
                  </div>
                  <div>
                    <p className="text-foreground-950 font-semibold text-sm">媒体人老王</p>
                    <p className="text-foreground-400 text-xs">资深娱乐记者</p>
                  </div>
                </div>
                <div className="text-accent-500 mb-3">
                  <i className="ri-double-quotes-l text-2xl"></i>
                </div>
                <p className="text-foreground-700 text-sm leading-relaxed">
                  "在娱乐新闻这个行当干了十五年，51爆料是我见过最敢说真话的平台。信息源扎实，处理速度快，而且从不跟风造谣。"
                </p>
              </div>

              <div className="bg-background-50 rounded-2xl p-5 md:p-6 border border-secondary-200/60">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                    <img
                      src="https://readdy.ai/api/search-image?query=Stylized%20abstract%20portrait%20of%20digital%20creator%2C%20warm%20taupe%20and%20cream%20tones%2C%20minimalist%20illustration%20style%2C%20clean%20background%2C%20modern%20aesthetic%2C%20creative%20vibe&width=100&height=100&seq=endorse-avatar-02&orientation=squarish"
                      alt="八卦早知道"
                      className="w-full h-full object-cover"
                      title="八卦早知道"
                    />
                  </div>
                  <div>
                    <p className="text-foreground-950 font-semibold text-sm">八卦早知道</p>
                    <p className="text-foreground-400 text-xs">微博百万大V</p>
                  </div>
                </div>
                <div className="text-accent-500 mb-3">
                  <i className="ri-double-quotes-l text-2xl"></i>
                </div>
                <p className="text-foreground-700 text-sm leading-relaxed">
                  "作为同行，我经常引用51爆料的独家内容。他们的深度追踪栏目做得特别好，每一篇都像在看侦探小说。"
                </p>
              </div>

              <div className="relative rounded-2xl overflow-hidden aspect-[4/5]">
                <img
                  src="https://readdy.ai/api/search-image?query=Abstract%20portrait%20of%20confident%20professional%20in%20warm%20dramatic%20lighting%2C%20dark%20background%20with%20amber%20highlights%2C%20editorial%20fashion%20photography%2C%20mysterious%20mood%2C%20rich%20burgundy%20and%20gold%20tones%2C%20cinematic%20quality&width=800&height=1000&seq=endorse-photo-03&orientation=portrait"
                  alt="KOL背书"
                  className="w-full h-full object-cover"
                  title="KOL背书"
                />
                <div className="absolute bottom-0 left-0 right-0 p-5 bg-gradient-to-t from-black/60 to-transparent">
                  <p className="text-background-50 font-semibold text-sm">匿名KOL</p>
                  <p className="text-background-50/60 text-xs">百万粉丝博主</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Business Matrix */}
        <section className="w-full bg-background-100 py-14 md:py-20">
          <div className="w-full px-4 md:px-6">
            <div className="flex flex-col lg:flex-row items-start gap-6 lg:gap-16 mb-10 md:mb-14">
              <div className="lg:w-1/3">
                <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-black text-foreground-950 leading-none tracking-tight">
                  我们的<br />业务线
                </h2>
              </div>
              <div className="lg:w-2/3">
                <p className="text-foreground-500 text-sm">
                  围绕娱乐爆料核心能力，51爆料已建立起多元化的内容矩阵，覆盖不同维度的吃瓜需求。
                </p>
              </div>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-5 md:gap-6">
              <div className="group bg-foreground-900 rounded-2xl p-5 md:p-6 flex flex-col cursor-pointer">
                <h3 className="text-background-50 text-lg md:text-xl font-bold mb-2 leading-snug">独家爆料</h3>
                <p className="text-background-50/60 text-sm leading-relaxed mb-5 flex-1">
                  一手信源，独家首发。每一条爆料都经过多层交叉验证，确保信息真实可靠。
                </p>
                <div className="w-full aspect-[16/10] rounded-xl overflow-hidden mt-auto">
                  <img
                    src="https://readdy.ai/api/search-image?query=Dark%20journalist%20desk%20with%20confidential%20documents%20and%20warm%20amber%20desk%20lamp%2C%20mysterious%20investigation%20atmosphere%2C%20cinematic%20composition%2C%20rich%20burgundy%20and%20gold%20tones%2C%20editorial%20photography%2C%20no%20people%2C%20exclusive%20story%20vibe&width=700&height=500&seq=biz-exclusive&orientation=landscape"
                    alt="独家爆料"
                    className="w-full h-full object-cover object-top"
                    title="独家爆料"
                  />
                </div>
              </div>

              <div className="group bg-background-50 rounded-2xl p-5 md:p-6 flex flex-col border border-background-200/60">
                <div className="flex items-center gap-2 mb-4">
                  <span className="inline-flex items-center gap-1 px-2.5 py-1 bg-accent-100 text-accent-700 text-xs font-semibold rounded-full">
                    <i className="ri-fire-line text-xs"></i>
                    热门
                  </span>
                </div>
                <div className="w-full aspect-[16/10] rounded-xl overflow-hidden mb-4">
                  <img
                    src="https://readdy.ai/api/search-image?query=Dark%20news%20room%20with%20multiple%20monitors%20displaying%20trending%20topics%2C%20warm%20amber%20and%20red%20data%20visualizations%2C%20mysterious%20atmosphere%2C%20cinematic%20composition%2C%20deep%20burgundy%20and%20gold%20tones%2C%20editorial%20photography%2C%20no%20people%2C%20real%20time%20tracking%20vibe&width=700&height=500&seq=biz-hottrack&orientation=landscape"
                    alt="热点追踪"
                    className="w-full h-full object-cover object-top"
                    title="热点追踪"
                  />
                </div>
                <h3 className="text-foreground-950 text-base md:text-lg font-bold leading-snug mb-1.5">热点追踪</h3>
                <p className="text-foreground-500 text-xs md:text-sm mb-4">
                  7×24小时蹲守全网热点，不放过任何一个可能引发舆论震荡的事件。
                </p>
                <div className="mt-auto">
                  <span className="inline-flex items-center gap-1.5 bg-primary-500 text-background-50 text-xs font-semibold px-4 py-2 rounded-full whitespace-nowrap cursor-pointer">
                    了解详情
                    <i className="ri-arrow-right-line text-xs"></i>
                  </span>
                </div>
              </div>

              <div className="group bg-background-50 rounded-2xl p-5 md:p-6 flex flex-col border border-background-200/60">
                <div className="flex items-center gap-2 mb-4">
                  <span className="inline-flex items-center gap-1 px-2.5 py-1 bg-secondary-100 text-secondary-700 text-xs font-semibold rounded-full">
                    <i className="ri-bar-chart-line text-xs"></i>
                    数据
                  </span>
                </div>
                <div className="w-full aspect-[16/10] rounded-xl overflow-hidden mb-4">
                  <img
                    src="https://readdy.ai/api/search-image?query=Abstract%20data%20visualization%20with%20warm%20amber%20and%20burgundy%20lines%20on%20dark%20background%2C%20sentiment%20analysis%20charts%2C%20mysterious%20digital%20atmosphere%2C%20cinematic%20composition%2C%20rich%20gold%20and%20deep%20shadow%20contrast%2C%20editorial%20style%2C%20no%20people%2C%20data%20intelligence%20theme&width=700&height=500&seq=biz-senti&orientation=landscape"
                    alt="舆情监测"
                    className="w-full h-full object-cover object-top"
                    title="舆情监测"
                  />
                </div>
                <h3 className="text-foreground-950 text-base md:text-lg font-bold leading-snug mb-1.5">舆情监测</h3>
                <p className="text-foreground-500 text-xs md:text-sm mb-4">
                  基于大数据和AI技术的舆情监测服务，为企业和艺人提供风险预警。
                </p>
                <div className="mt-auto">
                  <span className="inline-flex items-center gap-1.5 bg-primary-500 text-background-50 text-xs font-semibold px-4 py-2 rounded-full whitespace-nowrap cursor-pointer">
                    了解详情
                    <i className="ri-arrow-right-line text-xs"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Contact / Submission CTA */}
        <section id="contact" className="w-full bg-background-50 py-14 md:py-20">
          <div className="w-full px-4 md:px-6">
            <div className="flex flex-col items-center text-center mb-10 md:mb-14">
              <h2 className="font-heading text-3xl md:text-5xl font-black text-foreground-950 mb-4">
                有料要爆？
              </h2>
              <p className="text-foreground-400 text-sm md:text-base mb-8 max-w-md">
                联系51爆料，让真相被看见。我们保护每一位爆料者的隐私。
              </p>
            </div>

            <div className="max-w-xl mx-auto">
              <form onSubmit={handleSubmit} className="flex flex-col gap-4" data-readdy-form="">
                <div>
                  <label className="block text-foreground-700 text-sm font-medium mb-1.5">你的称呼</label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                    required
                    className="w-full px-4 py-3 bg-background-100 border border-background-200/60 rounded-lg text-foreground-950 text-sm placeholder:text-foreground-300 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all"
                    placeholder="怎么称呼你"
                  />
                </div>
                <div>
                  <label className="block text-foreground-700 text-sm font-medium mb-1.5">联系邮箱</label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                    required
                    className="w-full px-4 py-3 bg-background-100 border border-background-200/60 rounded-lg text-foreground-950 text-sm placeholder:text-foreground-300 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all"
                    placeholder="your@email.com"
                  />
                </div>
                <div>
                  <label className="block text-foreground-700 text-sm font-medium mb-1.5">爆料内容</label>
                  <textarea
                    name="content"
                    value={formData.content}
                    onChange={(e) => setFormData({ ...formData, content: e.target.value })}
                    required
                    maxLength={500}
                    rows={5}
                    className="w-full px-4 py-3 bg-background-100 border border-background-200/60 rounded-lg text-foreground-950 text-sm placeholder:text-foreground-300 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all resize-none"
                    placeholder="请详细描述你要爆料的内容，越详细越好..."
                  />
                  <p className="text-foreground-300 text-xs mt-1 text-right">{formData.content.length}/500</p>
                </div>
                <input
                  type="text"
                  name="website_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                  className="form-anti-spam"
                />
                {submitStatus !== 'idle' && (
                  <p className={`text-sm ${submitStatus === 'success' ? 'text-accent-600' : 'text-red-500'}`}>
                    {submitMsg}
                  </p>
                )}
                <button
                  type="submit"
                  disabled={submitStatus === 'loading'}
                  className="inline-flex items-center justify-center gap-2 px-7 py-3.5 bg-primary-500 text-background-50 text-sm font-semibold rounded-full hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer disabled:opacity-60"
                >
                  {submitStatus === 'loading' ? (
                    <>
                      <i className="ri-loader-4-line animate-spin"></i>
                      提交中...
                    </>
                  ) : (
                    <>
                      立即投稿
                      <i className="ri-arrow-right-line"></i>
                    </>
                  )}
                </button>
              </form>

              <div className="mt-8 pt-8 border-t border-background-200/60">
                <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 text-sm text-foreground-500">
                  <div className="flex items-center gap-2">
                    <i className="ri-mail-line"></i>
                    <span>联系邮箱：contact@51baoliao.com</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <i className="ri-time-line"></i>
                    <span>工作时间：全天24小时</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}